<script>

export default {
  name: "BrandWrapper",
  data() {
    return {
      brands: [],
    }
  },
  props: {
    slicer: {
      default: Infinity,
    },
  },
  render() {

    return this.$scopedSlots.default({
      brands: this.brands.length != 0 ? this.brands.data.data.slice(0, this.slicer) : [],
    });

  },
  async mounted() {
    this.brands = await this.$store.dispatch("Brand/getBrandsWithoutPagination");
  }
}
</script>
